import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { iconsAsset } from "../../environment/icons/iconExport";
import MultipartUploadFileArea from "./MultipartUploadFileArea";
import PowerShellCommand from "./PowerShellCommand";
import {
  AD_INVENTORY_COMMAND,
  AD_USERS_COMMAND,
  MicrosoftADFiles,
} from "./constants";

const InventoryUploadStep = ({ statusData }) => {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant={"subtitle1"}>
        Export & Upload Active Directory Inventory
      </Typography>

      <Box display="flex" flexDirection="column" gap={1} padding={2}>
        <Box display="flex" flexDirection="row" gap={1}>
          <Typography variant={"body2"}>1.</Typography>
          <Typography variant={"body2"}>
            Run the script on a machine in the same domain as the Group Policy
            export, using a Domain Admin account.
          </Typography>
        </Box>
        {/* INSTRUCTIONS */}
        <Box display="flex" flexDirection="column" gap={1} paddingLeft={2}>
          <Typography variant={"body2"} color={colors.text_secondary}>
            This generates an TXT file containing your Active Directory
            Inventory.
          </Typography>
        </Box>
        <PowerShellCommand
          command={AD_INVENTORY_COMMAND}
          label="Run in PowerShell as Administrator"
          minWidth="400px"
        />
      </Box>

      <Box display="flex" flexDirection="column" gap={1} padding={2}>
        <Box display="flex" flexDirection="row" gap={1}>
          <Typography variant={"body2"}>2.</Typography>
          <Typography variant={"body2"}>
            Run the script on a machine in the same domain as the Group Policy
            export, using a Domain Admin account.
          </Typography>
        </Box>
        {/* INSTRUCTIONS */}
        <Box display="flex" flexDirection="column" gap={1} paddingLeft={2}>
          <Typography variant={"body2"} color={colors.text_secondary}>
            This generates an CSV file containing your Active Directory User
            details.
          </Typography>
        </Box>
        <PowerShellCommand
          command={AD_USERS_COMMAND}
          label="Run in PowerShell as Administrator"
          minWidth="400px"
        />
      </Box>

      {/* Upload Areas for TXT and CSV files */}
      <Box display="flex" flexDirection="column" gap={1} padding={2}>
        <Box display="flex" flexDirection="row" gap={1}>
          <Typography variant={"body2"}>3.</Typography>
          <Typography variant={"body2"}>Upload the generated files:</Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={2} paddingLeft={2}>
          <Box display="flex" flexDirection="row" gap={2} flexWrap="wrap">
            <MultipartUploadFileArea
              fileKey={MicrosoftADFiles.INVENTORY.key}
              initialFileName={
                statusData?.file_mapping?.[MicrosoftADFiles.INVENTORY.key]
                  ?.original_file_name
              }
              fileFormat="TXT"
              label={
                <Box display="flex" alignItems="center" gap="6px">
                  <SvgToIcon IconLogo={iconsAsset.EntitiesIcon} width={16} />
                  <Typography variant={"body2"} color={colors.text_secondary}>
                    Active Directory Inventory
                  </Typography>
                </Box>
              }
            />
            <MultipartUploadFileArea
              fileKey={MicrosoftADFiles.USERS.key}
              initialFileName={
                statusData?.file_mapping?.[MicrosoftADFiles.USERS.key]
                  ?.original_file_name
              }
              fileFormat="CSV"
              label={
                <Box display="flex" alignItems="center" gap="6px">
                  <SvgToIcon IconLogo={iconsAsset.AssetsUserIcon} width={16} />
                  <Typography variant={"body2"} color={colors.text_secondary}>
                    Active Directory User Details
                  </Typography>
                </Box>
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InventoryUploadStep;
